


import {FBFieldWithPriceBaseOptions, PriceTypeEnum} from "FormBuilder/Fields/Core/FBFieldWithPriceBase.Options";

import {FieldTypeEnum} from "FormBuilder/Fields/Core/FBFieldBase.options";
import {OptionItem, AdditionalOptionColumn} from "FormBuilder/Fields/Options/OptionItem";
import {StoreAutoIncrement, StoreBase, StoreDataType} from "shared/core/Store/StoreBase";
import {FBMultipleOptionsBaseOptions} from "FormBuilder/Fields/Core/FBMultipleOptionsBase.Options";




export class FBCheckBoxOptions extends FBMultipleOptionsBaseOptions{
    public Placeholder:string;
    public MaximumNumberOfItems:number;

    protected LoadDefaultValues() {
        super.LoadDefaultValues();
        this.Type=FieldTypeEnum.Checkbox;
        this.Label='Checkbox';
        this.Placeholder='';
        this.PriceType=PriceTypeEnum.options;
        this.MaximumNumberOfItems=0;

        this.Options=[
            {Id:1, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 1'} as any,
            {Id:2, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 2'} as any,
            {Id:3, PriceType:PriceTypeEnum.fixed_amount,SalePrice:'',RegularPrice:'',Label:'Option 3'} as any
        ]


    }


}

